"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = void 0;
var _types = require("../../actions/stream/types");
var initialState = exports.initialState = true;
function canStartStream() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_STOP_STREAM) return false;
  if (action.type === _types.BROADCAST_STOP_STREAMS) return false;
  if (action.type === "".concat(_types.BROADCAST_STOP_STREAM, "_FAILURE")) return true;
  if (action.type === "".concat(_types.BROADCAST_STOP_STREAMS, "_FAILURE")) return true;
  if (action.type === _types.BROADCAST_SET_CAN_START_STREAM) return action.payload;
  return state;
}
var _default = exports["default"] = canStartStream;